<script>
	import { getContext, onDestroy } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { storeBuilderPreview, storeData, storeElementID, storeShowTools } from '../library/scripts/Store.svelte'

	const globals = getContext('globals')
	const fsS = globals.fsS
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	let elementID
	let isAdmin = false

	let showPreview
	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	let data
	const stoData = storeData.subscribe((value) => {
		data = value
	})

	if (data.widgets.indexOf('admin') > -1) isAdmin = true

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	onDestroy(() => {
		stoPreview
		stoData
	})
</script>

{#if !showPreview && isAdmin}
	<div
		class="content_row"
		use:styles={{ fsS, builderToolbar, builderToolbarHover }}
		on:click={() => set_elementID('Shop')}
		on:keydown={() => set_elementID('Shop')}
	>
		<div style="margin-left:20px;">*OPEN SITE TOOL*</div>
	</div>
{/if}

<style>
	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}
</style>
